const dsBridge = require('dsbridge')
// const STRINGRETURN = ['8', '7', 'getRegisterPhone', 'getRegisterCode']
export default function (key, cb) {
  if (localStorage.getItem('source') === 'ios') {
    if (dsBridge.hasNativeMethod('ios.handle')) {
      dsBridge.call('ios.handle', JSON.stringify([key]),
        function (res) {
          const confinacion = JSON.parse(res) || '""'
          cb(confinacion)
        })
    }
  } else if (localStorage.getItem('source') === 'android') {
    if (dsBridge.hasNativeMethod('android.handle')) {
      dsBridge.call('android.handle', JSON.stringify([key]),
        function (res) {
          const confinacion = JSON.parse(res) || '""'
          cb(confinacion)
        })
    }
  }
}
